import React, { useState } from 'react';
import classNames from 'classnames';
import AccessibilityModal from 'shared-core/accessibility/AccessibilityModal';
import styles from './FloatingAccessibilityButton.module.scss';

export const FloatingAccessibilityButton: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Route bazlı gizleme App.tsx'te, çerez bileşenleriyle aynı koşulda yapılır.
  // Burada yalnızca react-native-webview injection'ı kontrol edilir.
  if (window?.ReactNativeWebView) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className={classNames(styles.button, { [styles['button--active']]: isOpen })}
        aria-label="Erişilebilirlik Ayarları"
        aria-expanded={isOpen}
        title="Erişilebilirlik Ayarları"
      >
        <img
          src={isOpen ? '/icons/accessibility_icon_white.png' : '/icons/accessibility.png'}
          alt="Erişilebilirlik"
          aria-hidden="true"
          className={styles.icon}
        />
      </button>

      <AccessibilityModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default FloatingAccessibilityButton;
